import { SampleAssetRepository } from '@telespot/domain';
import { AnalysisStateRepository } from '../../ports/analysis-state.repository';
import { IMethodTypeAiEnabledPort } from '../../ports/method-type-ai-enabled.port';
import { AlgorithmAnalyzedAssetsCounter } from '../../services/algorithm-analyzed-assets.counter';
import { resolveSampleAiProgress, SampleAiAnalysisStatus } from './resolve-sample-ai-progress';

export interface GetSampleAiAnalysisProgressInput {
  sampleId: string;
  methodTypeId: string;
}

export type { SampleAiAnalysisStatus };

export interface GetSampleAiAnalysisProgressOutput {
  status?: SampleAiAnalysisStatus;
}

export interface IGetSampleAiAnalysisProgressUseCase {
  execute(input: GetSampleAiAnalysisProgressInput): Promise<GetSampleAiAnalysisProgressOutput>;
}

export class GetSampleAiAnalysisProgressUseCase implements IGetSampleAiAnalysisProgressUseCase {
  constructor(
    private readonly analysisStateRepository: AnalysisStateRepository,
    private readonly sampleAssetRepository: SampleAssetRepository,
    private readonly analyzedAssetsCounter: AlgorithmAnalyzedAssetsCounter,
    private readonly methodTypeAiEnabled: IMethodTypeAiEnabledPort
  ) {}

  async execute(input: GetSampleAiAnalysisProgressInput): Promise<GetSampleAiAnalysisProgressOutput> {
    const { sampleId, methodTypeId } = input;

    const [sampleAssets, analysisStatesBySample] = await Promise.all([
      this.sampleAssetRepository.findForSample(sampleId),
      this.analysisStateRepository.fetchAnalysisStatesForSamples([sampleId]),
    ]);

    return resolveSampleAiProgress({
      sampleId,
      methodTypeId,
      sampleAssets,
      analysisStates: analysisStatesBySample.get(sampleId) ?? [],
      methodTypeAiEnabled: this.methodTypeAiEnabled,
      analyzedAssetsCounter: this.analyzedAssetsCounter,
    });
  }
}
